// Date/time picker

$(function () {
  $('#settingsDateOfBirth').datetimepicker({
    locale: 'cs',
    format: 'L',
  });
});
